import { youtubeFacadeHtml } from '~/lib/media/youtube'

/**
 * Click-to-load YouTube video (16:9). Renders the same facade markup as
 * Markdown bodies; the click handler is installed in the root route.
 */
export function YouTubeEmbed({
  id,
  title,
  query,
  className = '',
}: {
  id: string
  title: string
  query?: string
  className?: string
}) {
  return (
    <div
      className={`aspect-video w-full ${className}`}
      dangerouslySetInnerHTML={{ __html: youtubeFacadeHtml(id, title, query) }}
    />
  )
}
